// src/v2/pages/Reports/ReportSSSCalamityLoan.js
import React from 'react';
import { GeneralMessage } from '../../../common/APICommon';
import { useReportSSSCalamityLoan } from '../../hooks/useReportSSSCalamityLoan';
import { ReportSSSCalamityLoanModule } from '../../components/modules/Reports/ReportSSSCalamityLoan/ReportSSSCalamityLoanModule';

const ReportSSSCalamityLoan = ({ isHideSideMenu }) => {
  const reportHook = useReportSSSCalamityLoan();

  return (
    <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
      <div className="LeftSpace"></div>
      <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
        <ReportSSSCalamityLoanModule reportHook={reportHook} />
      </div>
      <GeneralMessage form={reportHook.showMessage} message={reportHook.message} isSuccess={reportHook.isSuccess} />
    </div>
  );
};

export default ReportSSSCalamityLoan;